import { render } from "./AquaparkInfo.vue?vue&type=template&id=883369d8"
import script from "./AquaparkInfo.vue?vue&type=script&lang=js"
export * from "./AquaparkInfo.vue?vue&type=script&lang=js"

import "./AquaparkInfo.vue?vue&type=style&index=0&id=883369d8&lang=scss"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__